import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import axios from 'axios'
import '@/icons' // icon
import '@/permission' // permission control
import '@babel/polyfill'
import dataV from '@jiaminghi/data-view'
import echarts from 'echarts'
import filter from '@/filter/index'
import { post, storSet, storGet, storRemove, get, DayTo, DateTo, Date_GMT, sePost } from '@/utils/request'
// import socket from '@/vendor/socket'
import EmptyText from '@/components/EmptyText'
import EmptyBlank from '@/components/Empty'
import { contentPost } from '@/utils/contentRequest'



// set ElementUI lang to EN
// Vue.mixin(socket)
Vue.use(ElementUI)
Vue.use(dataV)
Vue.component('EmptyText', EmptyText)
Vue.component('EmptyBlank', EmptyBlank)
Vue.prototype.axios = axios
Vue.prototype.$echarts = echarts
Vue.prototype.DayTo = DayTo
Vue.prototype.DateTo = DateTo
Vue.prototype.Date_GMT = Date_GMT
Vue.prototype.post = post
Vue.prototype.sePost = sePost
Vue.prototype.contentPost = contentPost
Vue.prototype.get = get
Vue.prototype.session = {
  Get: storGet,
  Remove: storRemove,
  Set: storSet
}
for (const key in filter) {
  Vue.filter(key, filter[key])
}
if (process.env.NODE_ENV === 'production') {
  console.log = _ => {}
}
Vue.config.productionTip = false
// socket.on('connect', function(res) {
//   console.log(res, socket.connected, 'connect sim')
// })
// socket.on('error', function(res) {
//   console.log(res, 'error')
// })
// socket.on('connect_error', err => {
//   console.log(err, 'connect_error')
//   // socket.close()
// })
// socket.on('disconnect', res => {
//   console.log(res, 'disconnect')
// })
// socket.on('new_msg_notice', res => {
//   console.log(res, 'msg notice')
// })
setTimeout(() => {
  // socket.close()
}, 1000)
// Vue.config.$socket = null
// Vue.use(new VueSocketio({
//   debug: false,
//   // connection: 'http://192.168.0.234:5050/screenView',
//   options:{
//     // autoConnect: false,
//     // transports: ['websocket'],
//
//     extraHeaders:{
//       Authorization: "Bearer authorization_token_here",
//       customerGroupId:  storGet('screen') &&  storGet('screen').customerGroupId ? storGet('screen').customerGroupId : ''
//     },
//   },
//   connection: 'https://datav.eartip.cn/screenView'
//   // connection: 'http://119.23.211.94:5050/screenView'
// }))
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
